module.exports = __webpack_public_path__ + "media/crypto/skale-9cb14d56.png";